import {
  SkeletonBox,
  SkeletonContainer,
  SkeletonLabel,
} from "@/components/ui/skeleton";
import { NeuroscaleLogo } from "./neuroscale-logo";

export function AuthPageHeader({
  title,
  subtitle,
}: {
  title: string;
  subtitle: React.ReactNode;
}) {
  return (
    <div className="flex flex-col gap-4">
      <NeuroscaleLogo />
      <div className="flex flex-col gap-2">
        <h1 className="text-[28px] font-semibold text-foreground tracking-[-0.84px] leading-7">
          {title}
        </h1>
        <p className="text-base text-foreground/60 tracking-[-0.16px] leading-5">
          {subtitle}
        </p>
      </div>
    </div>
  );
}

export function AuthPageHeaderSkeleton({
  subtitleLines = 2,
}: {
  subtitleLines?: 1 | 2;
}) {
  return (
    <SkeletonContainer className="flex-col gap-4">
      <SkeletonBox className="h-7 w-48" />
      <div className="flex flex-col gap-2">
        <SkeletonBox className="h-7 w-3/4" />
        <div className="flex flex-col gap-1.5">
          <SkeletonLabel tone="muted" className="h-4 w-full" />
          {subtitleLines === 2 ? (
            <SkeletonLabel tone="muted" className="h-4 w-2/3" />
          ) : null}
        </div>
      </div>
    </SkeletonContainer>
  );
}
